$(document).ready(function () {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
      quickView();
    });
  });
  
  function quickView() {
    $(".quick-view").click(function () {
      if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
      var product_handle = $(this).data('handle');
      $('#quick-view').addClass(product_handle);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var desc = product.description;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var available = product.available;
        var url = '/products/' + product_handle;
        $('.qv-product-title').text(title);
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        if(available){
          $('.qv-add-button').prop('disabled', false).val('Agregar al carrito');
        }
        else{
          $('.qv-add-button').prop('disabled', true).val('Sin stock');
        }
        $('.view-product').attr('href', url);
        var imageCount = $(images).length;
        $(images).each(function (i, image) {
          if (i == imageCount - 1) {
            var image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-product-images').append(image_embed);
  
            $('.qv-product-images').slick({
              'dots': true,
              'arrows': false,
              'respondTo': 'min',
              'useTransform': false
            }).css('opacity', '1');
  
          } else {
            image_embed = '<div><img src="' + image + '"></div>';
            image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.qv-product-images').append(image_embed);
          }
        });
        $(options).each(function (i, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          $('.qv-product-options').append('<div class="select option-selection-' + opt.toLowerCase() + '"><span class="form__label option">' + opt + '</span><select class="select__select option-' + i + ' option ' + opt.toLowerCase() + '"></select>        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>');
          $(option.values).each(function (i, value) {
            $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          });
        });
        $(product.variants).each(function (i, v) {
          if (v.inventory_quantity == 0) {
            $('.qv-add-button').prop('disabled', true).val('Sold Out');
            $('.qv-add-to-cart').hide();
            $('.qv-product-price').text('Sold Out').show();
            return true
          } else {
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            $('.qv-product-price').text('$' + price);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
            } else {
              $('.qv-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
      });
  
      $(document).on("change", "#quick-view select", function () {
        var selectedOptions = '';
        $('#quick-view select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-product-price').text('$' + price);
              $('.qv-product-original-price').text('$' + original_price);
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val('Agregar al carrito');
              } else {
                if (v.inventory_quantity < 1) {
                  $('.qv-add-button').prop('disabled', true).val('Sin stock');
                } else {
                  $('.qv-add-button').prop('disabled', false).val('Agregar al carrito');
                }
              }
            }
          });
        });
      });
      $.fancybox({
        href: '#quick-view',
        maxWidth: 1040,
        maxHeight: 600,
        fitToView: true,
        width: '75%',
        height: '70%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        'beforeLoad': function () {
          var product_handle = $('#quick-view').attr('class');
          $(document).on("click", ".qv-add-button", function () {
            var qty = $('.qv-quantity').val();
            var selectedOptions = '';
            var var_id = '';
            $('#quick-view select').each(function (i) {
              if (selectedOptions == '') {
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
              $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {
                  var_id = v.id;
                  processCart();
                }
              });
            });
            function processCart() {
              jQuery.post('/cart/add.js', {
                quantity: qty,
                id: var_id
              },
                          null,
                          "json"
                         ).done(function () {
                $('.qv-add-to-cart-response').addClass('success').html(
                  '<span><svg width="1.3rem" class="icon icon-checkmark color-foreground-text" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path></svg>' +
                  $('.qv-product-title').text() + ' agregado al carrito. </span>'+
                  '<a href="/cart" class="button button--secondary button--full-width">Ver mi carrito</a>' +
                  '<form action="/cart" method="post" id="cart-notification-form"><button class="button button--primary button--full-width" name="checkout">Pagar pedido</button></form>'
                  );
              })
              .fail(function ($xhr) {
                var data = $xhr.responseJSON;
                $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
              });
            }
          });
          $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
            $('.qv-product-images').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view').removeClass().empty();
        }
      });
    });
  };
  
  $(window).resize(function () {
    if ($('#quick-view').is(':visible')) {
      $('.qv-product-images').slick('setPosition');
    }
  });